import React, { useState } from "react";
import {
  TextField,
  CircularProgress,
  Autocomplete,
} from "@mui/material";
import { getPetOwners } from "../../../api/petOwnerService";

const PetOwnerAutocomplete = ({
  value,
  onChange,
  label = "Select Pet Owner",
  ...props
}) => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleInputChange = async (event, inputValue, reason) => {
    if (reason === "input") {
      if (inputValue.length >= 2) {
        setLoading(true);
        try {
          const response = await getPetOwners(1, 10, inputValue);
          setItems(response?.data || []);
        } catch (error) {
          console.error("Error fetching items:", error);
        } finally {
          setLoading(false);
        }
      } else {
        // Clear items if input is less than 2 characters
        setItems([]);
      }
    }
  };

  const handleChange = (event, newValue) => {
    if (!newValue) {
      // User clicked clear (x) → clear options too
      setItems([]);
    }
    onChange?.(newValue ? newValue.id : "");
  };

  return (
    <Autocomplete
      {...props}
      options={items}
      getOptionLabel={(option) =>
        `${option.first_name} ${option.last_name} (${option.pet_names ? option.pet_names : "no pets"})` || ""
      }
      value={items.find((item) => item.id === value) || null}
      onChange={handleChange}
      onInputChange={handleInputChange}
      loading={loading}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <CircularProgress size={20} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
};

export default PetOwnerAutocomplete;
